import { render, staticRenderFns } from "./CourseTopicSelectbox.vue?vue&type=template&id=75f38de6"
import script from "./CourseTopicSelectbox.vue?vue&type=script&lang=js"
export * from "./CourseTopicSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports